module.exports = {"initialValues":{"equipmentValue":"70.000","optionalEquipValue":[{"key":"70.000","value":"Under 70.000 kr."},{"key":"90.000","value":"70-90.000 kr."},{"key":"110.000","value":"90-110.000 kr."},{"_delete":true},{"_delete":true}]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/car/package.car-fdm.json
// module id = 638
// module chunks = 0